<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4 align-items-center">
    <p class="text-xl font-semibold">{{ 'layout.configurations.currencies.title' | translate }}</p>
    <div class="flex gap-2">
    <p-button
      *emPermission="Permission.CONFIG_INVOICING"
      class="p-button-success"
      icon="pi pi-plus"
      [label]="'layout.configurations.currencies.addrateexchange.title' | translate"
      (onClick)="onAddRateExchange()"
      severity="success"
      ></p-button></div>
  </div>
    <!-- <p-table
  [value]="pivotedRows"
  [paginator]="true"
  [rows]="10"
  styleClass="w-full p-datatable-sm"> -->
  <!-- Date Range Filter -->
  <div class="flex align-items-center gap-3 mb-4 p-3 border-round"
       style="background: #f8fafc; border: 1px solid #e2e8f0;">
    <i class="pi pi-filter" style="color: #64748b;"></i>
    <span style="font-weight: 500; color: #374151; white-space: nowrap;">{{ 'layout.configurations.currencies.filter.from' | translate }}</span>
    <div class="flex align-items-center gap-2">
      <label style="font-size: 0.875rem; color: #6b7280;">{{ 'layout.configurations.currencies.filter.from' | translate }}</label>
      <p-calendar
        [(ngModel)]="filterStartDate"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        [placeholder]="'layout.configurations.currencies.filter.startDatePlaceholder' | translate"
        (onSelect)="applyDateFilter()"
        (onClearClick)="applyDateFilter()"
        [showButtonBar]="true"
        appendTo="body">
      </p-calendar>
    </div>
    <div class="flex align-items-center gap-2">
      <label style="font-size: 0.875rem; color: #6b7280;">{{ 'layout.configurations.currencies.filter.to' | translate }}</label>
      <p-calendar
        [(ngModel)]="filterEndDate"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        [placeholder]="'layout.configurations.currencies.filter.endDatePlaceholder' | translate"
        (onSelect)="applyDateFilter()"
        (onClearClick)="applyDateFilter()"
        [showButtonBar]="true"
        appendTo="body">
      </p-calendar>
    </div>
    <p-button
      *ngIf="filterStartDate || filterEndDate"
      icon="pi pi-times"
      label="{{ 'layout.configurations.currencies.filter.clear' | translate }}"
      severity="secondary"
      [outlined]="true"
      (onClick)="clearDateFilter()"
      styleClass="p-button-sm">
    </p-button>
  </div>
  <!-- Table -->
  <p-table
    [value]="pivotedRows"
    [paginator]="true"
    [rows]="10"
    styleClass="w-full p-datatable-sm">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="startdate" class="bg-white">
          {{ 'layout.configurations.currencies.startDate' | translate }}
          <p-sortIcon field="startdate"></p-sortIcon>
        </th>
         <th pSortableColumn="enddate" class="bg-white">
          {{ 'layout.configurations.currencies.endDate' | translate }}
          <p-sortIcon field="enddate"></p-sortIcon>
        </th>

      <th *ngFor="let c of displayedCurrencies" class="bg-white">
        {{ c }}
      </th>

        <th *emPermission="Permission.CONFIG_INVOICING" class="bg-white w-10rem text-center">
          {{ 'layout.configurations.currencies.actions' | translate }}
        </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      <td>{{ row.startdate | date: 'dd/MM/yyyy' }}</td>
      <td>{{ row.enddate | date: 'dd/MM/yyyy' }}</td>

      <td *ngFor="let c of displayedCurrencies">
        {{ row[c] ?? ' ' }}
      </td>

          <td *emPermission="Permission.CONFIG_INVOICING" class="text-center">
        <p-button
          icon="pi pi-pencil"
          [outlined]="true"
          class="mr-2"
          (onClick)="onEdit(row)">
        </p-button>

        <p-button
          icon="pi pi-trash"
          severity="danger"
          [outlined]="true"
          (onClick)="onDelete($event, row)">
        </p-button>
      </td>
    </tr>
  </ng-template>
 <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="2 + displayedCurrencies.length + 1" class="text-center py-4" style="color: #9ca3af;">
          {{ 'layout.configurations.currencies.noExchangeRatesFound' | translate }}
        </td>
      </tr>
    </ng-template>
</p-table>

</div>
